/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import React from 'react'

import PhotoContainer from 'containers/Photo'
import PhotoPane from 'components/PhotoPane'
import PhotosSidebar from 'components/PhotosSidebar'
import Layout from 'components/Layout'
import Logo from 'components/Logo'
import SiteTitle from 'components/SiteTitle'
import Nav from 'components/Nav'
import Helmet from 'react-helmet'

const Photo = ({ className, photo, photoNavigation }) => {
  return (
    <Layout gridName="docsGrid" className={className}>
      <Helmet title={photo.title} />
      <Logo className="logoRegion" />
      <SiteTitle className="titleRegion" title="651 - Gateway" />
      <Nav className="navRegion" />
      <PhotosSidebar
        photoNavigation={photoNavigation}
        className="sidebarRegion"
      />
      <PhotoPane photo={photo} className="fullPaneRegion region" />
    </Layout>
  )
}

export default PhotoContainer(Photo)
